import React, { FC, useMemo, useState } from 'react';
import { ServiceProviderInterface } from '../interfaces';

const { createContext, useContext } = React;

interface ResponseHandlerServiceInterface {
	showTime: number;
	error: Error | undefined;
	addError: (error: Error | undefined) => void;
	success: string | undefined;
	addSuccess: (message: string | undefined) => void;
}

interface ResponseHandlerProviderInterface extends ServiceProviderInterface {
	showTime: number;
}

const ResponseContext = createContext<ResponseHandlerServiceInterface>(
	{} as ResponseHandlerServiceInterface
);

export const ResponseHandlerProvider: FC<ResponseHandlerProviderInterface> = ({
	children,
	showTime,
}) => {
	const [error, addError] = useState<Error | undefined>(undefined);
	const [success, addSuccess] = useState<string | undefined>(undefined);

	const value: ResponseHandlerServiceInterface = useMemo(
		() => ({
			showTime,
			error,
			addError,
			success,
			addSuccess,
		}),
		[error, success, showTime]
	);

	return <ResponseContext.Provider value={value}>{children}</ResponseContext.Provider>;
};

export const useResponseHandlerService = () => {
	return useContext<ResponseHandlerServiceInterface>(ResponseContext);
};
